import $ from 'jquery'
import store_config from '@/store/mods/parametres/config'

export default {
    name: 'manage-param-sagefemme',
    components: {},
    props: {
        toggler: Number,
        del_toggler: Number,
        selected_section: Object,
        selected_param: Object
    },

    data() {
        return {
            param_cpn: {
                id: null,
                libelle: ''
            },

            save_loading: false,
            msg_error: '',

            is_confirm: false,
            del_loading: false,
            msg_error_del: ''
        }
    },

    watch: {
        toggler() {
            this.resetForm()
        },

        del_toggler() {
            this.is_confirm = false
            this.del_loading = false
            this.msg_error_del = ''
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        resetForm() {
            this.param_cpn = {
                id: (this.selected_param) ? this.selected_param.id : null,
                libelle: (this.selected_param) ? this.selected_param.libelle : ''
            }

            this.msg_error = ''
            this.save_loading = false

            if (this.$refs.param_sagefemme_form) {
                this.$refs.param_sagefemme_form.reset()
            }
        },

        async saveParamCpn() {
            const isValid = await this.$refs.param_sagefemme_form.validate();
            if (!isValid) {
                return;
            }

            const data = {
                id: this.param_cpn.id,
                libelle: this.param_cpn.libelle,
                data_type: this.selected_section.data_type
            }

            this.save_loading = true

            const request = (this.param_cpn.id != null)
                ? store_config.updateParamCpn(data)
                : store_config.saveParamCpn(data)

            request.then((response) => {
                if (response.success) {
                    this.$refs.param_sagefemme_modal.click()
                    this.$refs.param_sagefemme_form.reset();
                    this.$emit("emitRefreshParamCpn")
                    this.successToast(response.message)
                } else {
                    this.msg_error = response.message
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur est survenue lors de la sauvegarde des données"
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimerParamCpn() {
            let confirm = document.getElementById('cfrm-del-param-cpn');

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            const data = {
                id: this.selected_param.id,
                data_type: this.selected_section.data_type
            }

            store_config.deleteParamCpn(data).then((response) => {
                if (response.success) {
                    this.$refs.param_sagefemme_del_modal.click()
                    this.$emit("emitRefreshParamCpn")
                    this.successToast(response.message)
                    this.is_confirm = false
                } else {
                    this.msg_error_del = response.message
                }

                this.del_loading = false
            }).catch(() => {
                this.del_loading = false
                this.msg_error_del = "Une erreur est survenue lors de la suppression !"
            })
        }
    }
}